import React from "react"

import { SidekickInteractionContext } from "./SidekickInteractionContext"

/**
 * Minimal stub of SidekickInteractionContext for unauthenticated screens.
 * Provides the real SidekickInteractionContext so `useSidekickInteraction()` resolves.
 * AvatarOverlay only reads `shouldShowAvatar` (always true here) and no-op actions.
 * No microphone or conversation interactions are allowed in the public content library.
 */

const NO_OP = () => {}

const STUB_VALUE = {
  isConnected: false,
  isReconnecting: false,
  inputMode: "idle" as const,
  isMicLoading: false,
  isListening: false,
  isProcessing: false,
  isTransferring: false,
  isSidekickBusy: false,
  isSwitchingSidekick: false,
  canStartNewInteraction: false,
  shouldShowAvatar: true,
  inTransferGracePeriod: false,
  startTalkMode: NO_OP,
  startTypeMode: NO_OP,
  returnToIdle: NO_OP,
}

export function UnauthSidekickInteractionProvider({ children }: React.PropsWithChildren) {
  return (
    <SidekickInteractionContext.Provider value={STUB_VALUE}>
      {children}
    </SidekickInteractionContext.Provider>
  )
}
